export default __webpack_public_path__ + "static/media/x.19d55416.svg";